/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
/**
 * Updates a parameter in the URL hash without causing a page reload
 *
 * @param {string} paramName - The name of the parameter to update
 * @param {string} paramValue - The value to set for the parameter
 * @param history
 */
export const updateParamInUrlHash = (paramName, paramValue, history ) => {
    const params = new URLSearchParams(history.location.search || '');
    params.set(paramName, paramValue);
    history.push({ search: params.toString() });
};

/**
 * Updates the 'tab' parameter in the URL hash
 *
 * @param {string} tabValue - The tab value to set
 * @param history
 */
export const updateTabParamInUrl = (tabValue, history) => {
    updateParamInUrlHash('tab', tabValue, history);
};

/**
 * Updates the 'section' parameter in the URL hash
 *
 * @param {string} sectionValue - The section value to set
 * @param history
 */
export const updateSectionParamInUrl = (sectionValue, history) => {
    updateParamInUrlHash('section', sectionValue, history);
};
